import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

export type ConfirmDialogData = {
    title: string;
    message: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    type?: "warning" | "danger" | "info";
};

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-confirm-dialog",
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, FontAwesomeModule],
    templateUrl: "./confirm-dialog.component.html",
    styleUrl: "./confirm-dialog.component.scss",
})
export class ConfirmDialogComponent {
    readonly data: ConfirmDialogData = inject(MAT_DIALOG_DATA);
    private readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);

    get icon(): [string, string] {
        switch (this.data.type) {
            case "danger":
                return ["fas", "triangle-exclamation"];
            case "info":
                return ["fas", "circle-info"];
            default:
                return ["fas", "triangle-exclamation"];
        }
    }

    get confirmText(): string {
        return this.data.confirmButtonText ?? "CONFIRM";
    }

    get cancelText(): string {
        return this.data.cancelButtonText ?? "CANCEL";
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
